import React from 'react'

class ImageGroup extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ratios: [],
      elementToResize: null,
      ratio: null,
    }
  }

  handleLoad = (index, w, h) => {
    const { ratios } = this.state
    ratios[index] = h / w
    this.setState({ ratios }, this.checkImagesReady)
  }

  checkImagesReady = () => {
    const { ratios } = this.state
    if (ratios.length === 2 && ratios[0] !== ratios[1]) {
      this.setState({
        elementToResize: ratios[0] < ratios[1] ? 0 : 1,
        ratio: ratios[0] > ratios[1] ? ratios[0] : ratios[1],
      })
    }
  }

  render() {
    const { children, className } = this.props
    const { elementToResize, ratio } = this.state
    return (
      <div className={className}>
        {children(this.handleLoad, elementToResize, ratio)}
      </div>
    )
  }
}

export default ImageGroup
